import api from 'app/api';
import { identifyPostHogUser } from 'app/utils/postHog';
import { setSessionLoggedUser } from 'app/utils/sessionLogger';

import * as constants from './constants';

export function setUserInfo(payload) {
  return { type: constants.SET_USER_INFO, payload };
}

export function setUserInfoLoading(payload) {
  return { type: constants.SET_USER_INFO_LOADING, payload };
}

export function getUserInfo() {
  return function (dispatch) {
    dispatch(setUserInfoLoading(true));
    return api
      .getUserInfo()
      .then(_ => {
        dispatch(setUserInfo(_));
        setSessionLoggedUser(_);
        identifyPostHogUser(_);
      })
      .finally(() => {
        dispatch(setUserInfoLoading(false));
      });
  };
}

export function setModels(payload) {
  return { type: constants.SET_MODELS, models: payload };
}

export function setModelsLoading(payload) {
  return { type: constants.SET_MODELS_LOADING, payload };
}

export function getModels(subscriptionId) {
  return function (dispatch) {
    dispatch(setModelsLoading(true));
    return api
      .getMlModels('', subscriptionId, false)
      .then(_ => {
        dispatch(setModels(_?.results || []));
      })
      .finally(() => {
        dispatch(setModelsLoading(false));
      });
  };
}

export function updateModelList(subscriptionId) {
  return function (dispatch) {
    return api
      .getMlModels('', subscriptionId, false)
      .then(_ => {
        dispatch(setModels(_?.results || []));
      })
      .finally(() => {
        dispatch(setModelsLoading(false));
      });
  };
}

export function setDefects(payload) {
  return { type: constants.SET_DEFECTS, defects: payload };
}

export function setDefectsLoading(payload) {
  return { type: constants.SET_DEFECTS_LOADING, payload };
}

export function getDefects() {
  return function (dispatch) {
    dispatch(setDefectsLoading(true));
    return api
      .getDefects('')
      .then(_ => {
        dispatch(setDefects(_));
      })
      .finnaly(() => {
        dispatch(setDefectsLoading(false));
      });
  };
}

export function setUseCase(payload) {
  return { type: constants.SET_USE_CASE, payload };
}

export function setUseCaseLoading(payload) {
  return { type: constants.SET_USE_CASE_LOADING, payload };
}

export function setFeatureFlags(payload) {
  return { type: constants.SET_FEATURE_FLAGS, payload };
}

export function setFeatureFlagLoading(payload) {
  return { type: constants.SET_FEATURE_FLAGS_LOADING, payload };
}

export function setIsUrOrEnabled(payload) {
  return { type: constants.SET_IS_UR_OR_ENABLED, payload };
}

export function setLoadedSubscriptionId(payload) {
  return { type: constants.SET_LOADED_SUBSCRIPTION_ID, payload };
}
